<template>
    <div>
        <v-text-field
            dense=""
            v-model="info"
            @keyup="data(info, uid)"
            label="Enlace de vídeo"
            outlined
            rounded
        ></v-text-field>
    </div>
</template>

<script>
export default {
    props: ["data", "uid", "content"],
    data() {
        return {
            info: this.content
        };
    },
    watch: {
        content() {
            this.info = this.content;
        }
    }
};
</script>

<style></style>
